import { Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import Lottie from "react-lottie";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super();
    this.state = { error: null, errorInfo: null };
  }
  componentDidCatch(error, info) {
    this.setState({
      error,
      info,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <Box
          width={"100%"}
          height={"70%"}
          display={"flex"}
          justifyContent="center"
          flexDirection={"column"}
          alignItems="center"
        >
          <Lottie
            width={400}
            height={500}
            style={{ marginBottom: -100, marginTop: -100 }}
            options={{
              animationData: require("../assets/lotties/person-error.json"),
            }}
          />
          <Typography
            maxWidth={600}
            fontWeight={"600"}
            variant="h4"
            gutterBottom
            textAlign={"center"}
          >
            Ops, algo deu errado.
          </Typography>
          <Typography
            maxWidth={500}
            fontWeight={500}
            variant="body1"
            color="textSecondary"
            gutterBottom
            textAlign={"center"}
          >
            Infelizmente, ocorreu um erro inesperado. Se o problema persistir,
            entre em contato com nosso suporte pelo WhatsApp ou por ligação:
            <br />
            <Typography component={"span"} color="textPrimary" fontWeight={600}>
              (11) 5043-6556
            </Typography>
          </Typography>
          <Divider sx={{ my: 1, width: 100 }} />
          <Typography maxWidth={600} mb={2} textAlign={"center"}>
            Vamos tentar novamente?
          </Typography>
          <Button
            
            size="large"
            variant="contained"
            disableRipple
            sx={{transition: 'none'}}
            onClick={() => {
              window.location.reload();
            }}
          >
            Atualizar página
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
